import React, { useContext, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CartContext } from "./CartContext";
import "../css/payment-status.css";

const PaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const isSuccess = searchParams.get("state") === "success";
  const hasClearedCart = useRef(false);

  useEffect(() => {
    if (isSuccess && !hasClearedCart.current) {
      hasClearedCart.current = true;
      clearCart();
    }
  }, [clearCart, isSuccess]);

  return (
    <main className="payment-status-page">
      <section className={`payment-status-card ${isSuccess ? "is-success" : "is-cancel"}`}>
        <div className="payment-status-icon" aria-hidden="true">
          {isSuccess ? "✓" : "×"}
        </div>
        <p className="payment-status-eyebrow">
          {isSuccess ? "Payment complete" : "Payment not completed"}
        </p>
        <h1>{isSuccess ? "Thank you for your order" : "Your payment was canceled"}</h1>
        <p>
          {isSuccess
            ? "Your payment was successful. We will send your order confirmation to the email address you provided."
            : "No payment was completed. Your items are still in your bag, so you can return to checkout whenever you are ready."}
        </p>
        <div className="payment-status-actions">
          <Link to={isSuccess ? "/shop" : "/checkout"}>
            {isSuccess ? "Continue shopping" : "Return to checkout"}
          </Link>
          {!isSuccess && <Link to="/cartpage">View bag</Link>}
        </div>
      </section>
    </main>
  );
};

export default PaymentStatus;
